import { render, staticRenderFns } from "./IncompleteOrders.vue?vue&type=template&id=7a0c6274&"
import script from "./IncompleteOrders.vue?vue&type=script&lang=js&"
export * from "./IncompleteOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports